import { useEffect, useState } from "react"
import {
  createUser,
  deleteUser,
  getUsers,
  toggleUserStatus,
  updateUserRole
} from "../../api/api"

export default function AdminUsers() {
  const [users, setUsers] = useState([])
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "client" })
  const [error, setError] = useState("")

  async function loadUsers() {
    const res = await getUsers()
    setUsers(res.data)
  }

  useEffect(() => {
    loadUsers().catch((err) => setError(err.response?.data?.error || "Failed to load users"))
  }, [])

  async function changeRole(id, role) {
    await updateUserRole(id, role)
    loadUsers()
  }

  async function toggleUser(id) {
    await toggleUserStatus(id)
    loadUsers()
  }

  async function removeUser(id) {
    if (!window.confirm("Delete user?")) return
    await deleteUser(id)
    loadUsers()
  }

  async function addUser(e) {
    e.preventDefault()
    setError("")

    try {
      await createUser(form)
      setForm({ name: "", email: "", password: "", role: "client" })
      await loadUsers()
    } catch (err) {
      setError(err.response?.data?.error || "Could not create user")
    }
  }

  function update(field, value) {
    setForm((current) => ({ ...current, [field]: value }))
  }

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Users Management</h1>
          <p className="muted">Create users, change roles and enable or disable accounts.</p>
        </div>
      </div>

      <form className="card form-row" onSubmit={addUser}>
        <label>
          Name
          <input value={form.name} onChange={(e) => update("name", e.target.value)} />
        </label>
        <label>
          Email
          <input value={form.email} onChange={(e) => update("email", e.target.value)} required />
        </label>
        <label>
          Password
          <input
            type="password"
            value={form.password}
            onChange={(e) => update("password", e.target.value)}
            placeholder="8+ characters"
            required
          />
        </label>
        <label>
          Role
          <select value={form.role} onChange={(e) => update("role", e.target.value)}>
            <option value="client">Client</option>
            <option value="admin">Admin</option>
            <option value="superadmin">Super Admin</option>
          </select>
        </label>
        <button>Create user</button>
      </form>

      {error && <p className="error">{error}</p>}

      <div className="card table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Role</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user.email}</td>
                <td>{user.name || "-"}</td>
                <td>
                  <select value={user.role} onChange={(e) => changeRole(user._id, e.target.value)}>
                    <option value="client">Client</option>
                    <option value="admin">Admin</option>
                    <option value="superadmin">Super Admin</option>
                  </select>
                </td>
                <td>
                  <span className={user.isActive ? "status active" : "status inactive"}>
                    {user.isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                <td className="actions">
                  <button className="secondary" onClick={() => toggleUser(user._id)}>
                    {user.isActive ? "Disable" : "Enable"}
                  </button>
                  <button className="danger" onClick={() => removeUser(user._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
